Reverb.MobileMenu = {

  init: function init() {
    const menuTriggers = [
      '.site-header__mobile-menu-toggle',
      '.site-header__mobile-menu__close',
      '.site-header__mobile-menu a',
    ];

    function toggleMobileMenu(e) {
      const direction = !$(document.body).hasClass('mobile-menu-open');

      if (!$(e.target).attr('href') || $(e.target).attr('href') === '#') {
        e.preventDefault();
      }

      $('.site-header__mobile-menu').toggleClass('site-header__mobile-menu--active', direction);
      $(document.body).toggleClass('mobile-menu-open', direction);
    }

    $(menuTriggers.join(', ')).on('click', toggleMobileMenu);
  },
};

$(Reverb.MobileMenu.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/mobile/menu.js